<template>
<div v-show="showDialog" class="upload-dialog">
        <div :style="{ color: titleColor }" class="title">{{ uploadTitle }}
            <div class="icon-group">
                <div @click="handleShow" class="upload-icon icon-margin">
                    <svg-icon :icon-class="this.show ? 'upload-down' : 'upload-up'" class="upload-down-icon"></svg-icon>
                </div>
                <div @click="showDialog = false" class="upload-icon">
                    <svg-icon icon-class="upload-close" class="upload-close-icon"></svg-icon>
                </div>
            </div>
        </div>
        <div v-show="show" class="upload-content">
            <div v-show="showUploading" class="button-group">
                <div @click="handleAll" class="common-button button-pause">{{hasUploading
  ? $t('全部暂停#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1')
  : $t('全部开始#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1')}}</div>
                <div @click="handleAllRemove" class="common-button">{{$t("全部取消#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1")}}</div>
            </div>
            <div class="upload-content-list">
                <div class="item" v-for="task of missions" :key="task.tid">
                    <svg-icon :icon-class="getFileIcon(task)" class="upload-file-icon"></svg-icon>
                    <div class="item-info">
                        <div class="item-name">{{ task.name }}</div>
                        <div :style="getFileStatusInfo(task.status)" class="item-status">
                            <svg-icon v-show="getFileUploadIcon(task.status)" :icon-class="getFileUploadIcon(task.status)" class="upload-file-status-icon"></svg-icon>
                            {{ getFileStatus(task) }}
                            <span class="speed" v-show="task.status == 1">{{ speeder?.(task.tid) }}</span>
                        </div>
                    </div>
                    <svg-icon @click="handleUploadTask(task)" :icon-class="getUploadIcon(task.status)" class="icon-right upload-mission-icon"></svg-icon>
                    <svg-icon @click="handleResult(task)" :icon-class="getUploadResultIcon(task.status)" class="upload-mission-icon"></svg-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapState } from 'vuex';
import { fileImgName } from '@/utils/avatar';
import { FileStatus } from '@/constants/file';

export default {
  props: {
    fileUploader: {
      type: Object,
      default: null
    },
    isFolder: {
      type: Boolean,
      default: ''
    }
  },
  name: 'UploadDialog',
  components: {
  },
  data() {
    return {
      show: true,
      showDialog: false,
      titleColor: ''
    };
  },
  methods: {
    handleUploadTask(item) {
      switch (item.status) {
        case -1:
          this.onStartTask(item.tid);
          return;
        case 0:
          return;
        case 1:
          this.onPauseTask(item.tid);
          return;
        case 2:
          this.onStartTask(item.tid);
          return;
        case 3:
          return;
        default:
          break;
      }
    },
    handleResult(item) {
      if (item.status == 3) {
        if (item.isdir && this.isFolder) {
          this.$emit("open-item", item);
        } else {
          const { origin, pathname } = window.location;
          var openUrl = origin + pathname + `?fid=${item?.fileId}`;
          if (pathname == "/web/file") {
            openUrl = origin + pathname + `#/?fid=${item?.fileId}`;
          }
          window.open(openUrl);
        }
        return;
      }
      this.onRemoveTask(item.tid);
    },
    onStartTask(tid) {
      this.fileUploader?.resume(tid);
    },
    handleAll() {
      if (this.hasUploading) {
        this.tasks.filter((item) => item.status == 1 || item.status == 0).forEach((item) => {
          this.onPauseTask(item.tid);
        });
      } else {
        this.tasks.filter((item) => item.status == 2).forEach((item) => {
          this.onStartTask(item.tid);
        });
      }
    },
    onPauseTask(tid) {
      this.fileUploader?.pause(tid);
    },
    handleAllRemove() {
      this.tasks.filter((item) => item.status != 3).forEach((item) => {
        this.onRemoveTask(item.tid);
      });
    },
    onRemoveTask(tid) {
      this.fileUploader?.remove(tid);
    },
    handleShow() {
      this.show = !this.show;
    },
    getFileIcon(item) {
      const { name: fileName, isdir } = item;
      if (isdir) return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name.substr(index).replace('.', '');
      return fileImgName(ext);
    },
    formatFileSize(item, decimals = 2) {
      const bytes = item.size;
      if (typeof bytes === "string") {
        bytes = parseInt(bytes);
      }
      if (bytes === 0) return "0 B";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "K", "M", "G", "T", "P", "E", "Z", "Y"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    getFileStatus(item) {
      const info = FileStatus[item.status.toString()];
      switch (item.status) {
        case -1:
          return info;
        case 0:
          return info;
        case 1:
          return info + this.processer(item.tid);
        case 2:
          return info;
        case 3:
          return info + this.formatFileSize(item);
        default:
          break;
      }
    },
    getFileStatusInfo(status) {
      switch (status) {
        case -1:
          return { color: '#FF4747' };
        case 0:
          return { color: '#979797' };
        case 1:
          return { color: '#979797' };
        case 2:
          return { color: '#979797' };
        case 3:
          return { color: '#07BD7C' };
        default:
          break;
      }
    },
    getFileUploadIcon(status) {
      switch (status) {
        case -1:
          return '';
        case 0:
          return '';
        case 1:
          return 'upload-ing';
        case 2:
          return 'upload-ing';
        case 3:
          return 'upload-done';
        default:
          break;
      }
    },
    getUploadIcon(status) {
      switch (status) {
        case -1:
          return 'upload-replay';
        case 0:
          return '';
        case 1:
          return 'upload-pause';
        case 2:
          return 'upload-start';
        case 3:
          return '';
        default:
          break;
      }
    },
    getUploadResultIcon(status) {
      switch (status) {
        case -1:
          return 'upload-mission-close';
        case 0:
          return 'upload-mission-close';
        case 1:
          return 'upload-mission-close';
        case 2:
          return 'upload-mission-close';
        case 3:
          return 'upload-open';
        default:
          break;
      }
    },
    showUploadDialog(value) {
      this.showDialog = value;
    }
  },
  computed: {
    ...mapState({
      tasks: (state) => state.tasks,
      speeds: (state) => state.speeds,
      progresses: (state) => state.progresses
    }),
    missions() {
      return this.tasks.slice().reverse();
    },
    speeder() {
      return (tid) => {
        const speed = this.speeds.find((t) => t.tid === tid);
        if (!speed) return "";
        return `${speed.rate}/s`;
      };
    },
    processer() {
      return (tid) => {
        const progress = this.progresses.find((t) => t.tid === tid);
        if (!progress) return "";
        const value = ~~(progress.uploaded / progress.total * 100);
        return ` ${value}%`;
        // return `${progress.uploaded}/${progress.total} (${value})%`;
      };
    },
    showUploading() {
      // 仅存在失败、成功的，展示全部按钮
      if (this.tasks.every((item) => item.status == 3 || item.status == -1)) {
        return false;
      } else {
        return true;
      }
    },
    hasUploading() {
      // 存在上传任务，展示全部暂停
      if (this.tasks.some((item) => item.status == 0 || item.status == 1)) {
        return true;
      } else {
        return false;
      }
    },
    uploadTitle() {
      if (this.tasks.every((item) => item.status == 2)) {
        this.titleColor = '#F8A908';
        return intl.$t("全部暂停#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_2");
      }

      // 任意一个任务在传输
      if (this.tasks.some((item) => item.status == 1)) {
        this.titleColor = '#121317';
        return intl.$t("传输中...#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1");
      }
      // 没有任务在传输
      else {
        // 存在上传成功的任务
        if (this.tasks.some((item) => item.status == 3)) {
          if (this.tasks.some((item) => item.status == -1)) {
            this.titleColor = '#121317';
            return intl.$t("部分文件上传失败#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1");
          }
          if (this.tasks.some((item) => item.status == 2)) {
            this.titleColor = '#121317';
            return intl.$t("暂停#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1");
          }
          this.titleColor = '#07BD7C';
          return intl.$t("上传成功#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1");
        }
        // 不存在上传成功的任务
        else {
          if (this.tasks.some((item) => item.status == 2)) {
            this.titleColor = '#121317';
            return intl.$t("全部暂停#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_3");
          }
          this.titleColor = '#FF4747';
          return intl.$t("上传失败#!!!#src/pages/H5/Cloud/components/dialog/UploadDialog.vue_1");
        }
      }
    }
  },
  watch: {
  },
  created() {
  },
  destroyed() {

  }
};
</script>

<style lang="scss" scoped>
.upload-dialog {
    z-index: 999;
    box-sizing: border-box;
    position: absolute;
    bottom: 16px;
    right: 16px;
    width: 399px;
    background: #ffffff;
    border: 1px solid #E6E8EC;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 16px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;


    .title {
        box-sizing: border-box;
        width: 100%;
        height: 48px;
        background: #F5F6F7;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        padding: 12px 16px;

        .icon-group {
            display: flex;
            flex-flow: row;
        }

        .upload-icon {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                background: #ffffff;
            }
        }

        .icon-margin {
            margin-right: 8.5px;
        }

        .upload-down-icon {
            width: 14px;
            height: 8px;
        }

        .upload-close-icon {
            width: 11.67px;
            height: 11.67px;
        }
    }

    .upload-content {
        width: 100%;
        height: 228px;
        padding: 8px 16px;
        box-sizing: border-box;

        .button-group {
            width: 100%;
            display: flex;
            flex-flow: row;
            justify-content: flex-end;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #5D71FF;
            letter-spacing: 0;
            box-sizing: border-box;
            padding-bottom: 10px;

            .common-button {
                cursor: pointer;
            }

            .button-pause {
                margin-right: 16px;
            }
        }

        .upload-content-list {
            width: 100%;
            height: 180px;
            overflow-y: auto;

            .item {
                display: flex;
                flex-flow: row;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;

                .item-info {
                    flex: 1;

                    .item-name {
                        width: 265px;
                        overflow: hidden;
                        text-align: left;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #323233;
                    }

                    .item-status {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 12px;
                        color: #979797;

                        .speed {
                            margin-left: 8px;
                        }
                    }

                    .upload-file-status-icon {
                        width: 12px;
                        height: 12px;
                    }
                }

                .icon-right {
                    margin-right: 8px;
                }

                .upload-mission-icon {
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                }

                .upload-file-icon {
                    width: 36px;
                    height: 36px;
                    margin-right: 8px;
                }
            }
        }
    }
}
</style>
